import AIAgents from '@pages/ai-agents';
import AiAgentResult from '@pages/ai-agents/ai-agent-result';
import { decryptUserStorage } from '@reducers/UserSlice';
import { Permissions } from '@utils/constants/permissions';

import { aiAgentsPaths } from './paths';

const user = decryptUserStorage;

const routes = [
  {
    component: AIAgents,
    path: aiAgentsPaths.INDEX,
    permission: [Permissions.PERMISSION_OFFER]
  },
  {
    component: AIAgents,
    path: aiAgentsPaths.SCRIPT,
    permission: [Permissions.PERMISSION_OFFER]
  },
  {
    component: AiAgentResult,
    path: aiAgentsPaths.RESULT,
    permission: [Permissions.PERMISSION_CHAT_FLOW]
  }
];

export const aiAgentRoutes: typeof routes = [];

if (typeof user === 'object' && user) {
  routes.forEach(route => {
    if (route.permission) {
      if (user?.role) {
        if (route.permission?.every(p => user.role.permissions.includes(p))) {
          aiAgentRoutes.push(route);
        }
      } else if (user?.roleTokens && route.permission?.every(p => user.roleTokens![0]?.role?.permissions.includes(p))) {
        aiAgentRoutes.push(route);
      }
    } else {
      aiAgentRoutes.push(route);
    }
  });
}
